import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { App } from "./App";
import { applyTelegramTheme } from "./telegramTheme";
import "./styles.css";

const webApp = window.Telegram?.WebApp;
webApp?.ready();
webApp?.expand();
applyTelegramTheme(webApp);

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </StrictMode>
);
